<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    content-class="modal-medium"
    class="modal-container"
    title="サフィックス登録"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!--回線番号-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="IPsecGW回線番号"
                      :value="ipsecGW.enumber"
                    />
                  </v-col>
                </v-row>

                <!--回線数-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="IPsec回線数/IPsec回線接続上限数"
                      :value="`${ipsecGW.numberOfIpsec}/${ipsecGW.upperLimitIpsec}回線`"
                    />
                  </v-col>
                </v-row>

                <!--サフィックス-->
                <v-row>
                  <v-col>
                    <app-badge
                      :msg="
                        $filter.message(`info_sign_num_max`, {
                          sign: '.',
                          max: 32,
                        })
                      "
                      :isRequired="true"
                      :isInfo="true"
                      item="サフィックス"
                    />
                    <validation-provider
                      label="サフィックス"
                      name="suffix"
                      v-model="form.suffix"
                      :rules="{
                        required: true,
                        max: { length: 32 },
                        is_half_width_alpha_numeric_symbol2: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!--WANアドレス-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="WANアドレス"
                      :value="ipsecGW.wanAddress"
                    />
                  </v-col>
                </v-row>

                <!--IPsecGWアドレス-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="IPsecGWアドレス"
                      :value="ipsecGW.ipsecGatewayAddress"
                    />
                  </v-col>
                </v-row>

                <!--管理用アドレス①-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="管理用アドレス①"
                      :value="ipsecGW.manageAddress1"
                    />
                  </v-col>
                </v-row>

                <!--管理用アドレス②-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="管理用アドレス②"
                      :value="ipsecGW.manageAddress2"
                    />
                  </v-col>
                </v-row>

                <!--管理用アドレス③-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="管理用アドレス③"
                      :value="ipsecGW.manageAddress3"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn variant="flat" type="submit" color="primary">登録</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { VisibleIpSecGW } from "@/views/nwSetting/ipSecGw/IpSecGWList.vue";
import type { IpSecGWUpdateEntity } from "@/apis/IpSecGwApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "IpSecGWModify",
  props: {
    /** IPsecGW */
    ipsecGW: {
      type: Object as PropType<VisibleIpSecGW>,
      required: true,
    },
    /** IPsecGW排他情報 */
    keyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      form: {
        suffix: "",
        ipsecGatewayKeyId: this.keyId,
      } as IpSecGWUpdateEntity,
    };
  },
  methods: {
    async submit() {
      await this.$confirm(
        "IPsecGWの設定を行います。この設定は後から変更できません\n実施してよろしいですか？"
      );
      await this.$api.ipSecGw.update(this.ipsecGW.enumber, this.form);
      await (
        this.$refs.modal as typeof VueFinalModal & { ok: () => void }
      ).ok();
    },
  },
});
</script>
